module.exports = __webpack_public_path__ + "static/projekt_indywidualny_a02-258938b6c214fad0c02582f527e67e21.jpg";